// extracted by mini-css-extract-plugin
export default {"MessageBox":"Messages_MessageBox__H0Hfa"};